// extracted by mini-css-extract-plugin
export default {"loading":"Spinner_loading__4I6qv"};